/**
 * AppVersionBadge — Footer minimalista con la versión del bundle (prompt 0531).
 *
 * Lee `__APP_VERSION__` inyectado por vite.config.ts en build time
 * (formato `<version>+<git SHA>`). Sin llamadas runtime al backend.
 *
 * Posicionamiento: bottom-right fijo, baja prioridad visual (gris claro).
 * Click copia la versión al portapapeles para soporte rápido.
 */
import { useState, type JSX } from 'react';

export function AppVersionBadge(): JSX.Element {
  const [copied, setCopied] = useState(false);
  // Variable global inyectada por Vite (`define` en vite.config.ts).
  // En tests/SSR puede no existir → fallback "dev".
  const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';

  function handleClick(): void {
    if (typeof navigator !== 'undefined' && navigator.clipboard) {
      navigator.clipboard.writeText(version).then(
        () => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        },
        () => {
          /* clipboard write failed silently — no romper UX */
        },
      );
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      title={
        copied ? 'Copiado al portapapeles' : `V·IAnet Governance ${version} — click para copiar`
      }
      style={{
        position: 'fixed',
        bottom: 8,
        right: 12,
        zIndex: 50,
        padding: '4px 10px',
        fontFamily: "'JetBrains Mono', 'Cascadia Code', monospace",
        fontSize: 11,
        fontWeight: 500,
        color: copied ? '#1F3864' : '#8B92A5',
        background: copied ? '#D6E4F0' : 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(4px)',
        border: '1px solid #E2E6ED',
        borderRadius: 12,
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'all 0.18s ease',
      }}
    >
      v{version}
    </button>
  );
}
